import { IconButton } from "@mui/material";
import { MdEdit } from "react-icons/md";
import styled from "styled-components";
import React, { useState } from "react";

import OptionPopUp from "./OptionPopUp";
import MuiTable from "../../../../components/MuiTable";
import { Pagination } from "../../../../components";
import { colors } from "../../../css components/Style";

const Icon = styled(IconButton)`
  border: 1px solid ${colors.purple}!important;
  color: ${colors.purple}!important;
  height: 35px;
  width: 35px;
  margin: 0 5px;
  padding: 0 5px;
  &:hover {
    border: 1px solid ${colors.purple}!important;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  }
`;

export default function OptionList({ list, formikProps, editState }) {
  const [dialogState, setDialogState] = useState({
    state: false,
    id: "",
  });

  const [addOptionPopUp, setAddOptionPopUp] = useState({
    state: false,
    data: {},
  });

  const [page, setPage] = useState({
    page: 1,
    totalCount: list?.length,
    lastCount: 0,
  });

  function handlePagination(step, index) {
    setPage((prev) => ({
      ...prev,
      page: step === "index" ? index : prev + (step === "next" ? 1 : -1),
    }));
  }

  let columns = [
    { name: "option_value", label: "Option Value" },
    { name: "option_text", label: "Option Label" },

    {
      name: "is_active",
      label: "Status",
    },

    {
      name: "Action",
      label: "Action",
    },
  ];

  const renderCell = (col, value, row) => {
    if (col.name === "option_value") {
      return value;
    }

    if (col.name === "option_text") {
      return value;
    }

    if (col.name === "is_active") {
      return value ? "Active" : "Inactive";
    }

    if (col.name === "Action") {
      return (
        <Icon onClick={() => setAddOptionPopUp({ state: true, data: row })}>
          <MdEdit />
        </Icon>
      );
    }
  };

  function deleteOptions() {
    let newOptions = [...formikProps.values.options];
    newOptions.splice(dialogState.id, 1);
    formikProps.setValues((prevVal) => ({
      ...prevVal,
      options: newOptions,
    }));
  }

  return (
    <React.Fragment>
      <OptionPopUp
        setAddOptionPopUp={setAddOptionPopUp}
        addOptionPopUp={addOptionPopUp}
        formikProps={formikProps}
      />

      <MuiTable columns={columns} data={list} renderCell={renderCell} />

      {!!page.totalCount && (
        <Pagination
          style={{ marginTop: "20px" }}
          count={Math.ceil(page.totalCount / 10)}
          variant="outlined"
          color="secondary"
          page={page.page}
          onChange={(e, value) => handlePagination("index", value)}
        />
      )}
    </React.Fragment>
  );
}
